module.exports = __webpack_public_path__ + "static/img/7-inspur.1d921743.png";